import React from "react";
import view_icon from "../../assets/images/view_icon.svg";
import edit_icon from "../../assets/images/edit_icon.svg";
import delete_icon from "../../assets/images/delete_icon.svg";
import { formatDate } from "../../utils/dateUtils";

const FormulaListTable = ({ data = [], onView, onEdit, onDelete, currentPage, pageSize, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / pageSize);
  return (
    <div className="custom_table table-responsive">
      <div className="table-wrapper">
        <table className="table mb-0">
          <thead>
            <tr>
              <th>Formula Name</th>
              <th>Code</th>
              <th>Tax Apply</th>
              <th>Expression</th>
              <th>Description</th>
              <th>Created On</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id ?? index}>
                  <td>{item.name}</td>
                  <td>{item.code}</td>
                  <td>{item.taxApply}</td>
                  <td className="truncated-text" data-full-text={item.expression}>
                    {item.expression.length > 30
                      ? item.expression.substring(0, 30) + "..."
                      : item.expression}
                  </td>
                  <td className="truncated-text" data-full-text={item.description}>
                    {item.description.length > 30
                      ? item.description.substring(0, 30) + "..."
                      : item.description}
                  </td>
                  <td>
                    {formatDate(item.createdAt)}
                  </td>
                  <td>
                    <div className="action_links">
                      {/* use button so no default navigation */}
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={() => {
                          onView?.(item);
                        }}
                        aria-label="view"
                      >
                        <img src={view_icon} alt="view" />
                      </button>

                      <button
                        type="button"
                        className="btn btn-link p-0 ml-2"
                        onClick={() => onEdit?.(item)}
                        aria-label="edit"
                      >
                        <img src={edit_icon} alt="edit" />
                      </button>

                      <button
                        type="button"
                        className="btn btn-link p-0 ml-2"
                        onClick={() => onDelete?.(item)}
                        aria-label="delete"
                      >
                        <img src={delete_icon} alt="delete" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted py-3">
                  No formulas found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION FOOTER */}
      {totalRecords > 0 && (
        <div className="table_footer">
          <div className="footer_left">
            Showing {(currentPage - 1) * pageSize + 1}–
            {Math.min(currentPage * pageSize, totalRecords)} of{" "}
            {totalRecords} entries
          </div>

          <div className="footer_right">
            <button
              className="page_btn"
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            >
              ‹ Previous
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={`page_btn ${currentPage === i + 1 ? "active" : ""
                  }`}
                onClick={() => onPageChange(i + 1)}
              >
                {String(i + 1).padStart(2, "0")}
              </button>
            ))}

            <button
              className="page_btn"
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            >
              Next ›
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormulaListTable;
